import React, { Component, PropTypes } from 'react';
import Style from 'style-it';
import styleTemplate from './hero-image-template';
import { get } from 'lodash';
import { connect } from 'react-redux';

function injectTheme(styleTemplate) {
    return styleTemplate.replace(/\/?\@([a-zA-Z0-9\.]+)\@\/?/g, (match, key) => {
        const { themeData, currentTheme } = this.props;
        const theme = {
            ...this.props.currentTheme,
            button: themeData.buttons.button,
            palette: themeData.colors,
            background: themeData.colors.background,
            h1: themeData.global.h1,
            h2: themeData.global.h2,
            h3: themeData.global.h3,
            h4: themeData.global.h4,
            h5: themeData.global.h5,
            font: themeData.global.font,
            link: themeData.buttons.link,
            heroImage: themeData.header.heroImage,
            header: {
                ...currentTheme.header,
                userBar: {
                    ...themeData.header.userBar
                },
                hamburgerMenu: {
                    ...themeData.header.hamburgerMenu
                }
            },
            calendar: themeData.calendar.calendar,
            gallery: themeData.carousel.gallery
        };
        //Do path search
        return get(theme, key, get(currentTheme, key, ''));
    });
}

class HeroImage extends Component {
    render() {
        return Style.it(
            injectTheme.bind(this)(styleTemplate),
            <div className="hero">
                <div className="image" style={{ height: '425px' }} />
                <div className="container">
                    <div className="hotelDetails">
                        <h2 className="hotelName">Stokes Inn</h2>
                        <p className="address">
                            <span>
                                <span className="addressLine">Hyderabad India</span>
                                <span className="addressLine">Hyderabad India</span>
                            </span>
                        </p>
                        <p className="phone">1111111111</p>
                        <p className="reservation">ModifyReservation</p>
                        <p className="website">Hotel Website</p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        currentTheme: state.app.selected.currentTheme,
        themeData: state.app.data.theme
    };
};

export default connect(mapStateToProps)(HeroImage);



// WEBPACK FOOTER //
// ./src/components/ngbe_base/hero-image/hero-image.js